import React from 'react';
import PoweredBy from '../components/PoweredBy';
import { BASE_URL } from '../config';

interface Props {
  error?: {
    code: string | null;
    message: string;
  };
  merchantCode?: string;
}

const CTALink = (
  <a target='_blank' rel='noreferrer' href={BASE_URL}>
    {BASE_URL}
  </a>
);

const ErrorPage: React.FC<Props> = ({ error, merchantCode }) => {
  const title = 'Whoopsie daisy!';
  const subtitle = 'Looks like this wasn’t meant to happen.';

  const getErrorMessage = (error: any) => {
    switch (error?.code) {
      case '404':
        return {
          message: (
            <>
              We could not find an entity with the merchant code <span className='break-all'>{merchantCode}</span>. You
              can find your merchant code in {CTALink}{' '}
              or ask your CarbonClick account manager.
            </>
          ),
        };
      default:
        return {
          message: <>Something went wrong. Please try again later or contact your CarbonClick account manager.</>,
        };
    }
  };

  if (!error) {
    return null;
  }

  return (
    <div className='error-page bg-light p-5' style={{ maxHeight: 770 }}>
      <div className='justify-center items-center text-center flex-column gap-6 max-w-md mx-auto py-44 mobile-py-24'>
        <h1 className='font-secondary-300 error-text'>{title}</h1>
        <h3 className='font-primary-600'>{subtitle}</h3>

        <div className='p-4 bg-white'>
          <p className='font-primary-400 leading-relaxed'>{error && getErrorMessage(error)?.message}</p>
        </div>

        <p className='text-sm font-primary-400 text-secondary'>
          If you believe there’s been a mistake, please contact our team at{' '}
          <a href='mailto:support@carbonclick.com'>support@carbonclick.com</a>
        </p>
      </div>

      <PoweredBy direction={'column'} />
    </div>
  );
};

export default ErrorPage;
